module.exports = __webpack_public_path__ + "static/photoCamera-93037188f2cdf543708fadba9d1d9fc7.png";